import {PickupPoint} from "./pickup-point";

export class Balikovna extends PickupPoint {

	init() {
		window.addEventListener('message', (message) => {
			if (message.data.message === 'pickerResult') {
				this.callback(message.data.point)
			}
		});
	}

	callback = (location) => {

		// provided zip isn't zip but pickup point id
		let parsed = location.address.match(/.*, ([0-9]{5}), (.*)/); // Vladivostocká 1460/10, Vršovice, 10000, Praha 10
		let zip = parsed[1];
		let city = parsed[2];
		if (!city) {
			city = location.municipality_name;
		}
		if (!zip) {
			zip = location.zip;
		}

		this.set_address({
			'pickup_point_id': location.zip, // location.id has an extra B at start
			'company_name': location.name,
			'address_line_1': location.street,
			'city': city,
			'zip': zip
		})

		this.close_pickup()
	}

	open_pickup() {
		jQuery(document).trigger('open_modal', ['checkout-balikovna', '', true])
	}

	close_pickup() {
		jQuery(document).trigger('close_modal')
	}

}
